export default __webpack_public_path__ + "static/media/wind.431e79b9.ogg";